import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {
    AsgFwContext,
    AsgDictionaryContext,
    AsgAppContext,
    AsgAppGamesContext,
    AsgToolsContext,
} from './contexts';
import { GameSearchWrapper } from './components/GameSearchWrapper/GameSearchWrapper';

export const renderNewSearch = (element) => {
    const { store } = AsgSharedComponents.state;
    let elm = element;
    if (typeof elm === 'string') {
        elm = document.getElementById(element);
    }

    elm && createRoot(elm).render(
        <Provider store={store}>
            <AsgFwContext.Provider value={AsgFW}>
                <AsgDictionaryContext.Provider value={Dictionary}>
                    <AsgAppContext.Provider value={AsgApp}>
                        <AsgAppGamesContext.Provider value={Games}>
                            <AsgToolsContext.Provider value={Tools}>
                                <GameSearchWrapper />
                            </AsgToolsContext.Provider>
                        </AsgAppGamesContext.Provider>
                    </AsgAppContext.Provider>
                </AsgDictionaryContext.Provider>
            </AsgFwContext.Provider>
        </Provider>
    );
};

